<template>
  <div class="drag-drop-pdf">
    <div class="question-title-pdf" style="font-weight: bold; font-size: 14px; padding-bottom: 8px; color: #000">
      Câu {{ question.index + 1 }}:
    </div>

    <div v-if="question.html" class="mb-4 question-content-pdf">
      <div class="processed-content" v-html="renderContentWithAnswers"></div>
    </div>

    <div v-if="optionsPool.length > 0" class="mb-2 mt-2">
      <div class="font-weight-medium mb-1" style="font-size: 14px; font-weight: bold">Danh sách lựa chọn:</div>
      <div style="display: block; width: 100%; padding-left: 8px">
        <div
          v-for="opt in optionsPool"
          :key="opt.key"
          style="display: inline-block; margin-right: 25px; margin-bottom: 5px; vertical-align: top"
        >
          <span style="margin-right: 4px; font-size: 14px">{{ opt.label }}.</span>
          <div
            class="custom-inline-html"
            style="display: inline-block; font-size: 14px"
            v-html="formatInlineHtml(opt.value)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'

export default {
  props: {
    question: Object,
    isQuestionPaper: Boolean,
    submission: Object,
  },
  computed: {
    optionsPool() {
      const poolSource = this.question.answers || {}
      const answers = Array.isArray(poolSource) ? poolSource : Object.values(poolSource)
      return answers
        .map(a => ({key: a.key, label: a.label, value: a.value}))
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
    },

    renderContentWithAnswers() {
      if (this.question.type === 'drag-drop-child') return ''

      let content = this.question.html || ''
      if (this.isQuestionPaper || !this.submission || !this.submission.answers) return content

      const children = this.question.questions || []

      return content.replace(/\{\{(.*?)\}\}/g, (match, tag) => {
        const cleanTag = tag.trim()
        const childQuestion = children.find(q => String(get(q, 'config.key')) === cleanTag)

        if (!childQuestion) return match

        const childId = childQuestion.id || childQuestion._id
        const studentAnsData = get(this.submission, `answers.${childId}`, null)

        if (!studentAnsData || !studentAnsData.answer) return match

        const isCorrect = studentAnsData.isCorrect
        const studentChoiceKey = studentAnsData.answer

        const studentOption = this.optionsPool.find(opt => opt.key === studentChoiceKey)
        const studentLabel = studentOption ? studentOption.label : '?'

        const resultColor = isCorrect ? '#4bca81' : '#d4504c'
        const iconChar = isCorrect ? '&#10003;' : '&#x2715;'
        const isStudentWork = get(this.submission, 'isStudentWork', false)

        return `
  ${match} 
  <span style="color: ${isStudentWork ? '#000' : resultColor}; font-size: 14px; margin-left: 6px; font-weight: bold;">
    [${studentLabel}] ${
          isStudentWork
            ? ''
            : `<span style="margin-left: 2px; font-size: 13px; vertical-align: middle;">${iconChar}</span>`
        }
  </span>
`
      })
    },
  },
  methods: {
    formatInlineHtml(html) {
      if (!html) return ''
      return html
        .replace(/<p/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/p>/g, '</span>')
        .replace(/<div/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/div>/g, '</span>')
    },
  },
}
</script>

<style scoped>
.question-content-pdf {
  line-height: 1.8;
  font-size: 14px;
}
.processed-content >>> p {
  margin-bottom: 2px;
}
</style>
